import React from 'react';
import ClientInvoiceAdminItem from '../../../Domain/ClientInvoiceAdminItem';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import dateTimeHelper from '../../../Helpers/datetimeHelper';
import ClientInvoiceService from '../../../Services/ClientInvoiceService';

export default class FinalizeClientInvoiceWindowDescription extends React.Component {
  static titleForEdit = (editedItem) => `Finalize Client Invoice (${editedItem.CiId})`;
  static finishButtonLabel = 'Finalize';
  static itemType = ClientInvoiceAdminItem;
  static serviceFunction = ClientInvoiceService.FinalizeInvoice;

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'FulfillmentDate',
          label: 'Fullfillment Date',
          className: 'col-12',
          type: InputTypesEnum.Date,
          validityChecker: FinalizeClientInvoiceWindowDescription.validateFulfillmentDate,
          hide: (item) => item.CiOfficeId.toString() !== '9',
        },
        {
          fieldName: 'Comment',
          label: 'Comment',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
      ],
    },
  ];

  static validateFulfillmentDate(e, editedItem) {
    if (editedItem.CiOfficeId.toString() === '9') {
      const fulfillmentDate = new Date(e);
      const lowerLimit = new Date(dateTimeHelper.toYYYYsMMsDD(dateTimeHelper.addDaysToDate(new Date(), 1)));
      const upperLimit = FinalizeClientInvoiceWindowDescription.calculateUpperLimit();
      if (fulfillmentDate < lowerLimit || fulfillmentDate >= upperLimit || e === 'NaN-NaN-NaN') {
        return "The date can't be before tomorrow or later than end of month + 60 days.";
      }
    }

    return '';
  }

  static calculateUpperLimit() {
    const year = new Date().getFullYear();
    const month = new Date().getMonth();
    const endOfMonth = new Date(year, month, dateTimeHelper.LastDayOfMonth(year, month));
    return dateTimeHelper.addDaysToDate(endOfMonth, 61);
  }
}
